<mat-toolbar class="p-2 flex flex-row gap-2 justify-{{position}} items-center">
  <button mat-stroked-button type="button" (click)="close.emit()">
    <ng-container i18n>Close</ng-container>
  </button>
</mat-toolbar>
